function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 21 21",
  fill: "none"
}, props),
/*#__PURE__*/
React.createElement("path", {
  stroke: "#354147",
  strokeWidth: "2",
  d: "M1 1h19v19H1z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M5 14l2.75-3.132 4.654.737L16 7",
  stroke: "#354147",
  strokeWidth: "2"
})));